// extracted by mini-css-extract-plugin
export var actionButton = "_fb-0";
export var fileInput = "_fb-2";
export var paperclip = "_fb-1";